import { useFormContext } from 'react-hook-form';
import { Fragment, useEffect, useRef, useState } from 'react';

import { debounce } from 'lodash';

const SearchInput = ({
  registerName,
  data,
  onClick
}: {
  registerName: string;
  data: { name: string; issuer: string }[];
  onClick: (index: number) => void;
}) => {
  const { register, setValue } = useFormContext();
  const [hasFocus, setHasFocus] = useState(false);

  const buttonRef = useRef<HTMLButtonElement>(null);
  const divRef = useRef<HTMLDivElement>(null);

  const inputDebounce = debounce(e => {
    setValue(registerName, e.target.value);
    setValue('issuerId', '');
  }, 1000);

  const handleOutsideClick = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setHasFocus(false);
      return;
    }

    if (
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      setHasFocus(false);
    } else {
      setHasFocus(true);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <div ref={divRef} className="relative">
      <input
        {...register(registerName, {
          required: true
        })}
        onChange={e => {
          inputDebounce(e);
        }}
        className={`${
          data?.length && 'focus:rounded-b-0 focus:border-b-transparent'
        } peer w-full bg-transparent border border-[#494949] p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999]`}
        placeholder="자격증명을 입력해 주세요"
        onFocus={() => setHasFocus(true)}
      />
      {data && hasFocus ? (
        <>
          {data.map((value, index) => {
            return (
              <Fragment key={`${value.issuer}_${index}`}>
                <div className="flex absolute z-1 top-[52px] bg-[#181818] text-[#999] text-[14px] border border-solid border-[#494949] rounded-5 p-16 w-full rounded-t-0 h-350 overflow-y-scroll flex-col gap-24">
                  <div className="flex justify-between items-center">
                    <div className="text-[#EAE8ED] text-[16px] flex flex-col gap-4">
                      <p>{value.name}</p>
                      <p className="text-[14px] text-[#8E899F]">
                        {value.issuer}
                      </p>
                    </div>
                    <button
                      ref={buttonRef}
                      type="button"
                      className="bg-[#9170F2] text-[14px] px-14 py-8 rounded-8 text-white"
                      onClick={() => {
                        onClick(index);
                        setHasFocus(false);
                      }}
                    >
                      선택
                    </button>
                  </div>
                </div>
              </Fragment>
            );
          })}
        </>
      ) : null}
    </div>
  );
};

export default SearchInput;
